export default __webpack_public_path__ + "static/media/meli.d1644e10.png";